import type { Scholarship } from '../../../../types/scholarships';

/**
 * "Total roster spots: 34 · 4 remaining" in a roster view's counts strip. Board-wide, like the
 * academic figure beside it: the spots are the plan's, not the filtered set's. A board with no
 * limit says how many are filled rather than inventing a remainder.
 */
export const RosterSpotsCount = ({ scholarship }: { scholarship: Scholarship }) => {
  const { rosterLimit } = scholarship;
  const { rosterFilled, rosterRemaining, isOverRosterLimit } = scholarship.summary;
  return (
    <span className="depth-chart-counts__item" data-testid="count-roster-spots">
      Total roster spots:{' '}
      {rosterLimit == null ? (
        <>
          <strong>{rosterFilled}</strong> filled, no limit set
        </>
      ) : (
        <>
          <strong>{rosterLimit}</strong>
          <span
            className={
              isOverRosterLimit
                ? 'roster-spots__remaining roster-spots__remaining--over'
                : 'roster-spots__remaining'
            }
          >
            {isOverRosterLimit
              ? ` · ${Math.abs(rosterRemaining ?? 0)} over`
              : ` · ${rosterRemaining ?? 0} remaining`}
          </span>
        </>
      )}
    </span>
  );
};
